import { weiToEth } from '@/lib/web3/utils';
import dayjs from 'dayjs';
import BigNumber from 'bignumber.js';
export type resTxDataProps = {
  height: string;
  timestamp: string;
  chain_id: string;
  to: string;
  value: string;
  hash: string;
  status: string;
};
export const txData = (aData: any, addr: `0x${string}`): resTxDataProps[] => {
  const list = aData?.tx_responses
    .filter((item: any) => item.tx.body.messages[0].data?.data === null)
    .map((item: any) => {
      const obj: resTxDataProps = {
        height: item.height,
        timestamp: dayjs(item.timestamp).format('YY-MM-DD hh:mm:ss'),
        chain_id: item.tx.body.messages[0].data.chain_id,
        to: item.tx.body.messages[0].data.to,
        value: BigNumber(weiToEth(item.tx.body.messages[0].data.value)).toFormat(4, 1),
        hash: item.tx.body.messages[0].hash,
        status: item.tx.body.messages[0].data?.to === addr ? 'in' : 'out',
      };
      return obj;
    });
  return list;
};

export const heightSortByDesc = (aData: any): any[] => {
  const list = aData.sort((a: any, b: any) => {
    return b.block - a.block;
  });
  return list;
};
